export default "__VITE_ASSET__DYl17CSe__"